<template>
  <v-container fluid>
    <section v-if="!!fileData">
      <QuickNavigation :fileData="fileData" :routeHistory="$route" />
      <v-row>
        <v-col cols="12">
          <div class="text-h6">Disclosure Delivery Options</div>
          <v-radio-group
            v-model="fileData.disclosureDeliveryOption"
            :rules="[required]"
            row
            dense
            title="fileData.disclosureDeliveryOption"
            hide-details="auto"
          >
            <v-radio label="Broker Provide Disclosures" :value="1"></v-radio>
            <v-radio label="NWL Provide PDF Disclosures" :value="2"></v-radio>
            <v-radio label="NWL Provide E-Sign Disclosure" :value="3"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" md="6">
          <v-combobox
            v-model="fileData.mainContactEmailList"
            label="Additional email(s) to be added for all notification for this loan"
            @change="filterEmailList"
            outlined
            dense
            chips
            clearable
            multiple
            single-line
            append-icon=""
            hide-details="auto"
          >
            <template v-slot:selection="{ attrs, item, select, selected }">
              <v-chip
                v-bind="attrs"
                :input-value="selected"
                color="info"
                close
                @click="select"
                @click:close="removeMainContactEmailList(item)"
              >
                <strong>{{ item }}</strong>
              </v-chip>
            </template>
          </v-combobox>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="fileData.mainContactPhone"
            label="Main Contact Phone"
            v-mask="$store.state.mask.phone"
            :rules="[phone]"
            outlined
            dense
            hide-details="auto"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-radio-group
            v-model="fileData.isBrokerCredit"
            :rules="[required]"
            row
            class="my-1"
            dense
            title="fileData.isBrokerCredit"
            hide-details="auto"
          >
            <v-radio label="Use Broker Credit" :value="true"></v-radio>
            <v-radio label="Use Lender Credit" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <V-col cols="12">
          <v-btn @click="createSubmissionForm()"> Store Submission Form</v-btn>
        </V-col>

        <v-col cols="12">
          <v-textarea
            label="Note to Underwriter"
            v-model="underwriterNote"
            hide-details="auto"
            outlined
            dense
          ></v-textarea>
        </v-col>
        <V-col cols="12">
          <v-btn @click="createUnderwritingNote()"> Save Note </v-btn>
        </V-col>
      </v-row>

      <!-- underwriterNote -->
    </section>
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import { rules, common, convert } from "@/mixins";

export default {
  name: "LoanSubmissionFormGenerator",
  components: {
    QuickNavigation,
  },
  async mounted() {
    this.fileData = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
        option: "All",
      })
      .then((resp) => resp.data)
      .catch(() => null);
  },
  data() {
    return {
      param: this.$route.query.loanNumber,
      fileData: null,
      underwriterNote: null,
    };
  },
  methods: {
    createSubmissionForm() {
      console.log("...processing");
      console.log(JSON.stringify(this.toOriginTypeFileData(this.fileData)));
      this.$store
        .dispatch(
          "fileDataApi/createSubmissionForm",
          this.toOriginTypeFileData(this.fileData)
        )
        .finally(() => {
          console.log("End");
        });
    },
    createUnderwritingNote() {
      console.log("...processing");
      this.$store
        .dispatch("fileDataApi/createUnderwritingNote", {
          loanNumber: this.fileData.fileName,
          note: this.underwriterNote,
        })
        .finally(() => {
          console.log("End");
        });
    },
    filterEmailList(v) {
      for (let i = 0; i < v.length; i++) {
        if (
          !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            v[i]
          )
        ) {
          this.removeMainContactEmailList(v[i]);
          break;
        }
      }
    },
    removeMainContactEmailList(item) {
      this.fileData.mainContactEmailList.splice(
        this.fileData.mainContactEmailList.indexOf(item),
        1
      );
      this.fileData.mainContactEmailList = [
        ...this.fileData.mainContactEmailList,
      ];
    },
  },
  mixins: [common, convert, rules],
};
</script>
